import React, {Fragment} from 'react';
import './LicenseIndicator.css';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {I18n} from "aws-amplify/utils";

/**
 * Signale les installations sans licence ou la fin de la période d'essai.
 * @param {object} props
 * @param {number} props.missingLicenses
 * @param {import('../../../Models/DomainTypes').PayStation[]} [props.payStations]
 */
const LicenseIndicator = props => {

    if( ! props.missingLicenses || props.missingLicenses < 1 ) {
        return null;
    }

    const renderTrial = () => {
        if( !props.payStations || props.payStations?.length < 1 ) {
            return (
                <div className={`trial-expired-block`}>
                    <div className={`trial-message`}>{I18n.get('Trial expired')}</div>
                </div>
            );
        }
        return null;
    };

    return (
        <Fragment>
            <div className={`license-indicator`}>
                <div className={`icon-license`}><FontAwesomeIcon icon="fa-solid fa-lock" /></div>
                <div className={`label-license`}>{`${props.missingLicenses} ${I18n.get('Installations requires a license')}`}</div>
            </div>
            {renderTrial()}
        </Fragment>
    );
};

export default LicenseIndicator;
